import React from 'react';
import { Container } from 'react-bootstrap';
import SprintSectionHeader from './sprint-section-header';

export default function SprintPillCards({ 
    label, 
    titlePrefix, 
    highlightText, 
    titleSuffix, 
    subtitle, 
    items, 
    hoverDirection = 'right', // 'right' or 'up'
    sectionClass = 'sprint-ideal'
}) {
    return (
        <section className={sectionClass}>
            <Container>
                {label || titlePrefix || highlightText ? (
                    <SprintSectionHeader 
                        label={label}
                        titlePrefix={titlePrefix}
                        highlightText={highlightText}
                        titleSuffix={titleSuffix}
                        subtitle={subtitle}
                        center={true}
                    />
                ) : null}
                
                <div className="sprint-ideal-grid">
                    {items && items.map((item, idx) => (
                        <div className={`sprint-pill-card hover-${hoverDirection} sprint-reveal sprint-delay-${(idx % 6) + 1}`} key={idx}>
                            <div className="sprint-pill-card-icon">{item.icon}</div>
                            <span>{item.label}</span>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
